import { clsx } from 'clsx';

const RequiredSpan = ({
  className,
}: {
  className?: HTMLDivElement['className'];
}) => (
  <span
    className={clsx(['text-error', className])}
    data-testid="required star"
    role="note"
  >
    *
  </span>
);

export { RequiredSpan };
